const APP_V2_URL = import.meta.env.VITE_APP_V2_URL;
const APP_ROOT_URL = import.meta.env.VITE_APP_ROOT_URL;

const isAllowedOrigin = (origin: string): boolean => {
  if (origin === window.location.origin) return true;
  for (const allowed of [APP_V2_URL, APP_ROOT_URL]) {
    if (!allowed) continue;
    try {
      if (new URL(allowed).origin === origin) return true;
    } catch {
      // ignore malformed env value
    }
  }
  return false;
};

export const getSafeRedirectUrl = (
  redirectUrl: string | null | undefined
): string | null => {
  if (!redirectUrl) return null;

  // Every value goes through the parser, including one that looks like a plain
  // relative path. The URL parser strips ASCII tab and newline before parsing,
  // so "/\t/evil.com" is protocol-relative to the browser but not to any
  // prefix check — only the parsed origin says where navigation really lands.
  try {
    const parsed = new URL(redirectUrl, window.location.origin);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return null;
    }
    if (!isAllowedOrigin(parsed.origin)) return null;
    return parsed.toString();
  } catch {
    return null;
  }
};
